// // api/policyApi.js
// import api from './config';

// const BASE_URL = 

// // Helper function for file downloads
// const handleFileDownload = (response) => {
//   const url = window.URL.createObjectURL(new Blob([response.data]));
//   const link = document.createElement('a');
//   link.href = url;

//   const contentDisposition = response.headers['content-disposition'];
//   let filename = 'document';

//   if (contentDisposition) {
//     const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
//     if (match && match[1]) {
//       filename = match[1].replace(/['"]/g, '');
//     }
//   }

//   link.setAttribute('download', filename);
//   document.body.appendChild(link);
//   link.click();
//   link.remove();
//   window.URL.revokeObjectURL(url);

//   return { success: true };
// };

// export const getPolicies = (params = {}) => api.get('/policies', { params });

// export const getPolicy = (id) => api.get(`/policies/${id}`);

// export const createPolicy = (formData) => {
//   console.log("Creating policy with FormData:", formData);
//   console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL);
//   return api.post(`${process.env.REACT_APP_API_BASE_URL}/api/policies`, formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   });
// };

// export const updatePolicy = (id, formData) => {
//   const config = {
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   };
//   return api.put(`/policies/${id}`, formData, config);
// };

// export const deletePolicy = (id) => api.delete(`/policies/${id}`);

// export const downloadPolicy = (id) =>
//   api.get(`/policies/${id}/download`, { responseType: 'blob' })
//     .then(handleFileDownload);

// export const getPolicyStats = () => api.get('/policies/stats');





// api/policyApi.js
import api from './config';
const API_BASE_URL = '';

const BASE_URL = ''; // Fixed: added quotes

// Helper function for file downloads
const handleFileDownload = (response) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;

  const contentDisposition = response.headers['content-disposition'];
  let filename = 'document';

  if (contentDisposition) {
    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (match && match[1]) {
      filename = match[1].replace(/['"]/g, '');
    }
  }

  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return { success: true };
};

export const getPolicies = async (params = {}) => {
  try {
    const response = await api.get('/policies/get_allpolicies', { params });
    // Transform the response to match what PolicyList expects
    if (response.data && response.data.success) {
      const policies = response.data.policies || [];
      return {
        data: policies,
        pagination: {
          total: policies.length,
          totalPages: Math.ceil(policies.length / (params.limit || 10)),
          currentPage: params.page || 1
        }
      };
    }
    return { data: [], pagination: { total: 0, totalPages: 0, currentPage: 1 } };
  } catch (error) {
    console.error('Error fetching policies:', error);
    throw error;
  }
};

export const getPolicy = (id) => api.get(`/policies/${id}`);

export const createPolicy = (payload) => {
  console.log("Creating policy with payload");

  // Use relative path - the base URL is already set in api config
  return api.post('/policies', payload, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const updatePolicy = (id, payload) => {
  return api.put(`/policies/${id}`, payload, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    withCredentials: true
  });
};

export const deletePolicy = (id) => api.delete(`/policies/${id}`);

export const downloadPolicy = (id) =>
  api.get(`/policies/${id}/download`, { responseType: 'blob' })
    .then(handleFileDownload);

export const getPolicyStats = () => api.get('/policies/stats');